<template>
    <kt-row class="col-12">
        <kt-col lg="6" md="6" sm="6" xs="12" style="margin-top: 15px;display: inline-block">
            <kt-form-group>
                <kt-form-label for="default_psp">
                    {{ $t('transaction_routing.choose_psp') }}
                </kt-form-label>
                <kt-form-select
                        id="default_psp"
                        name="default_psp"
                        @change="setDefaultPspBillGenerators(false)"
                        v-model="settings.default_psp"
                        class="form-control"
                >
                    <option
                            v-bind:key="index"
                            v-for="(psp, index) in activeBillPsp"
                            v-bind:value="psp.value"
                            :selected="psp.value === settings.default_psp"
                    >
                        {{ psp.title }}
                    </option>
                </kt-form-select>

            </kt-form-group>
        </kt-col>
        <kt-col lg="6" md="6" sm="6" xs="12" style="margin-top: 15px;display: inline-block"
                v-if="psp_corporates">
            <kt-form-group>
                <kt-form-label v-show="settings.default_psp == pspList.PASARGAD" for="default_corporate">
                    {{ $t('label.chose_default_corporate') }}
                </kt-form-label>
                <kt-form-label v-show="settings.default_psp == pspList.MELLAT" for="default_corporate">
                    {{ $t('bill-service.chose_mellat_bill_code') }}
                </kt-form-label>
                <select
                        id="default_corporate"
                        name="default_corporate"
                        v-model="settings.default_corporate"
                        class="form-control"
                >
                    <option value="" :selected="settings.default_corporate === ''">
                        {{ $t('selectpicker.nothing_selected') }}
                    </option>
                    <option
                            v-for="corporate in psp_corporates"
                            v-bind:key="corporate.id"
                            v-bind:value="corporate.id"
                            :selected="settings.default_corporate == corporate.id"
                    >
                        {{ corporate.business_name }}
                    </option>
                </select>
            </kt-form-group>
        </kt-col>
    </kt-row>
</template>

<script>
import $ from 'jquery'
import {mapGetters} from 'vuex'
import {pspList, activeBillPsp} from '@/constants/psp'
import {i18n} from '@/plugins/i18n'

export default {
    data() {
        return {
            psp_corporates: null,
            pspList,
            activeBillPsp
        }
    },
    props: {
        settings: {
            default() {
                return {}
            },
            type: Object
        }
    },
    computed: {
        ...mapGetters('bill', [
            'corporates'
        ]),
    },
    methods: {
        afterDispatch() {
            $('.kt-selectpicker').selectpicker({
                size: 4,
                liveSearch: false,
                noneResultsText: i18n.t('selectpicker.none_result'),
                selectAllText: i18n.t('selectpicker.select_all'),
                noneSelectedText: i18n.t('selectpicker.nothing_selected')
            })
        },
        setDefaultPspBillGenerators(first_try) {
            if (!first_try)
                this.settings.default_corporate = ''
            let psp = this.settings.default_psp
            if (!psp) return
            this.psp_corporates = []
            for (let i = 0; i < this.corporates.length; i++) {
                if (this.corporates[i]['psp'] === psp) {
                    this.psp_corporates.push(this.corporates[i])
                }
            }
        },
    },
    mounted() {
        this.$store.dispatch('bill/getCorporates').then(res => {
            this.setDefaultPspBillGenerators(true)
            this.afterDispatch()
        })

    }
}
</script>

<style>
</style>